export default __webpack_public_path__ + "static/media/WAS_S_XLG.715de95b.png";